module.exports = __webpack_public_path__ + "img/thumbs-down-active.27e104d8.svg";